import { useEffect, type ReactNode } from 'react';
import { Screen } from '@tempmee/react';
import { Box, Column, Stepper, BackButton } from '~/commonComponents';

const SHIFT_REQUEST_STEPS = ['Select Dates', 'Shift Details', 'Add Invites', 'Review & Confirm'];

interface IShiftRequestHeaderProps {
  currentStep: number;
  onBack?: () => void;
  backUrl?: string;
  maxWidth?: number;
  children: ReactNode;
}

export const ShiftRequestHeader = ({
  currentStep,
  onBack,
  backUrl,
  maxWidth,
  children,
}: IShiftRequestHeaderProps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Screen variant="standard">
      <Screen.Header start={<BackButton onClick={onBack} url={backUrl} />} title="Shift Request" />
      <Screen.Body style={maxWidth ? { maxWidth, width: '100%', alignSelf: 'center' } : undefined}>
        <Column paddingHorizontal={28} paddingTop={24} paddingBottom={60}>
          <Box maxWidth={700} margin="0 auto 32px" width="100%">
            <Stepper steps={SHIFT_REQUEST_STEPS} currentStep={currentStep} />
          </Box>
          {children}
        </Column>
      </Screen.Body>
    </Screen>
  );
};
